import { render, staticRenderFns } from "./NzPricing.vue?vue&type=template&id=1d4717d4"
import script from "./NzPricing.vue?vue&type=script&lang=js"
export * from "./NzPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports